import { render, staticRenderFns } from "./HeadProjected.vue?vue&type=template&id=37589c16"
import script from "./HeadProjected.vue?vue&type=script&lang=js"
export * from "./HeadProjected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports